import { render } from "./SkeletonLoader.vue?vue&type=template&id=ec5b33d8"
import script from "./SkeletonLoader.vue?vue&type=script&lang=js"
export * from "./SkeletonLoader.vue?vue&type=script&lang=js"

import "./SkeletonLoader.vue?vue&type=style&index=0&id=ec5b33d8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__